const C = require("../constants");

const ticketDialog = (data) => {
    return {
        type: C.TICKET_DIALOG,
        data
    }
};

export {ticketDialog};


// WEBPACK FOOTER //
// ./src/actions/TicketDialogActions.js